(ns ycweb.app.website.myaccount.registries.registries
  (:require
   [ycweb.components.flow :as flow]
   [rum.core :as rum]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]
   [ycweb.util.hash :as hash]
   [ycweb.util.date :as ud]
   [ycweb.util.urlstate :as urlstate]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.feedback :as feedback]
   [ycweb.components.headings :as headings]
   [ycweb.app.website.myaccount.common :as awm.common]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.common :as cmn]))

(rum/defc registries-line < rum/reactive [app-atom registry]
  (let [{:registry/keys [id status close-date total-qty purchase-qty order-id]
         :client-order/keys [order-status]
         :ent/keys [image display-name]} registry
        new-cart-enabled
        (cmn/curact app-atom [:features :new-cart])]

    [:tr.yc-tr
     [:td.yc-td.yc-td--hide
      (if (not-empty (:doc/public-id image))
        [:img.avatar {:src (u/cloudinary (:doc/public-id image) {:h 48 :w 48}) :alt ""}]
        [:img.avatar {:src (u/cloudinary "registries/default/registry_avatar_140_140" {:h 48 :w 48}) :alt ""}])]
     [:th.yc-th {:scope "row"}
      [:span display-name]]
     [:td.yc-td
      [:span.yc-td__faux-table {:data-th "Registry"}
       [:span.yc-td__faux-td
        (cond
          (= order-status "Registry")
          [:a.text-link {:href (str "/registry.htm?action=edit&orderid=" order-id)} (str "YC" order-id)]

          (= order-status "Abandoned Cart")
          [:a.text-link
           (cond
             (and new-cart-enabled (:registry/resume-props registry))
             (urlstate/href-props app-atom "order" "ShowCart" (:registry/resume-props registry))

             :else
             (urlstate/href-props app-atom "myaccount" "setcart" {:orderid order-id}))
           (str "YC" order-id)]

          (= order-status "Order Placed")
          [:a.text-link
           (if new-cart-enabled
             (urlstate/href-props app-atom "order" "ShowCart"
               {:step "payment/method-postcheckout" :orderid order-id :h (hash/sha256 (str order-id)) :ref "myaccount"})
             {:href (str "/order.htm?action=paymentoptions&id=" order-id "&h=" (hash/sha256 (str order-id)) "&ref=myaccount")})
           (str "YC" order-id)]

          :else
          [:a.text-link
           (urlstate/href-props app-atom "myaccount" "trackview"
             {:orderid order-id :registryid id})
           (str "YC" order-id)])]]]
     [:td.yc-td
      [:span.yc-td__faux-table {:data-th "Date"}
       [:span.yc-td__faux-td
        [:span.clip-date.unclip-date--t.clip-date--ma.unclip-date--l {:data-date "15/12/20"}
         [:span.clip-date__text (ud/date-format (ud/coerce-date close-date) "dd MM YYYY")]]]]]
     [:td.yc-td
      [:span.yc-td__faux-table {:data-th "Selected"}
       [:span.yc-td__faux-td
        [:span (str (u/number-format total-qty) " Gifts")]]]]
     [:td.yc-td
      [:span.yc-td__faux-table {:data-th "Purchased"}
       [:span.yc-td__faux-td
        (cond
          (= order-status "Registry")
          [:a.text-link.text-link--muted
           {:href (str "/registry.htm?action=edit&orderid=" order-id "&registryCartSort=purchased" (if (> purchase-qty 0) "#purchased" "#unpurchased"))}
           (str purchase-qty " Purchased")]

          :else
          [:a.text-link.text-link--muted
           {:href (str "/registry.htm?action=guestpurchaselist&orderid=" order-id)}
           (str purchase-qty " Purchased")])]]]
     [:td.yc-td
      [:span.yc-td__faux-table {:data-th "Options"}
       [:span.yc-td__faux-td
        (cond
          (= order-status "Registry")
          [:a.text-link {:href (str "/registry.htm?action=close&orderid=" order-id)} "Finalise" [:span.yc-table__name-clip " for Delivery"]]

          (= order-status "Paid")
          [:span.text-status--success "Paid"]

          (= order-status "Sent to Courier")
          [:span.text-status--success "Sent to Courier"]

          (= order-status "Delivered")
          [:span.text-status--success "Delivered"]

          :else
          [:span.text-status--error "Closed"])]]]
     [:td.yc-td.yc-td--centered
      [:span.yc-td__faux-table {:data-th "Edit"}
       [:span.yc-td__faux-td
        (cond
          (= order-status "Registry")
          [:a.text-link
           {:href (str "/registry.htm?action=edit&orderid=" order-id)} "Manage / Edit"]

          (= order-status "Abandoned Cart")
          [:a.text-link
           (cond
             (and new-cart-enabled (:registry/resume-props registry))
             (urlstate/href-props app-atom "order" "ShowCart" (:registry/resume-props registry))

             :else
             (urlstate/href-props app-atom "myaccount" "setcart" {:orderid order-id}))
           "Checkout"]

          (= order-status "Order Placed")
          [:a.text-link
           (if new-cart-enabled
             (urlstate/href-props app-atom "order" "ShowCart"
               {:step "payment/method-postcheckout" :orderid order-id :h (hash/sha256 (str order-id)) :ref "myaccount"})
             {:href (str "/order.htm?action=paymentoptions&id=" order-id "&h=" (hash/sha256 (str order-id)) "&ref=myaccount")})
           "Pay"]

          (= order-status "Delivered")
          [:a.text-link
           (urlstate/href-props app-atom "myaccount" "trackview" {:orderid order-id :registryid id})
           "View"]

          :else
          [:a.text-link
           (urlstate/href-props app-atom "myaccount" "trackview" {:orderid order-id :registryid id})
           "Track"])]]]]))

(rum/defc registries-table < rum/reactive [app-atom registries]
  [:table.yc-table
   (into
     [:tbody.yc-tbody]
     (map
       (fn [registry]
         (rum/with-key
           (registries-line app-atom registry)
           (str (:ent/uuid registry))))
       registries))])

(rum/defc registries < rum/reactive [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        registries-lines (cmn/curact process-atom :registries)

        new-cart-enabled
        (cmn/curact app-atom [:features :new-cart])]
    [:div.dashboard
     (headings/heading "Wedding Registries" {:type :h2 :size :medium})

     (map
       (fn [registry]
         [:div
          (let [order-id (:orderid registry)]
            (cond
              (and
                (= (:status registry) "Abandoned Cart")
                (or
                  (not new-cart-enabled)
                  (and new-cart-enabled (:registry/resume-props registry))))

              (feedback/feedback :info "Complete Registry Checkout to Order Your Gifts"
                [:span "We see you've set your Registry (YC" order-id ") to closed, but in
             order to secure your gifts and delivery, you need to finish the "
                 [:a.text-link
                  (cond
                    new-cart-enabled
                    (when (:registry/resume-props registry)
                      (urlstate/href-props app-atom "order" "ShowCart" (:registry/resume-props registry)))

                    :else
                    (urlstate/href-props app-atom "myaccount" "setcart" {:orderid order-id}))
                  "Checkout"]
                 " process. "
                 [:a.text-link.js-mfp-open-url
                  {:href "/help.htm?action=article&id=41"
                   :data-title "Closing Your Registry"
                   :target_url "/help.htm?action=article&id=41&overrideincludes=blank"}
                  "Need help"] "?"])

              (= (:status registry) "Order Placed")
              (feedback/feedback :info "Complete Registry Payment to Order Your Gifts"
                [:span "We see you've checked out your Registry (YC" (:orderid registry) "), but in order to
             secure your gifts and delivery, you need to finish the "
                 [:a.text-link
                  (urlstate/href-props app-atom "order" "paymentoptions" {:ref "myaccount" :id order-id :h (hash/sha256 (str order-id))})
                  "Payment"]
                 " process. "
                 [:a.text-link.js-mfp-open-url
                  {:href "/help.htm?action=article&id=41"
                   :data-title "Closing Your Registry"
                   :target_url "/help.htm?action=article&id=41&overrideincludes=blank"} "Need help"] "?"])))])
       registries-lines)

     (if (not-empty registries-lines)
       (registries-table app-atom registries-lines)
       [:div
        {:class (u/bem :no-data-wrapper :yc-section [:standard])}
        [:div.no-data-view
         [:p "You don't have any open Wedding Registries."]
         [:div
          {:class (u/bem :button-wrapper [:align-center])}
          (buttons/button-web "Create a Registry"
            (urlstate/href-props app-atom "registry" "create"))]]])

     (toaster/loading-overlay app-atom :web.myaccount/registries)]))

(defmethod flow/render-screen :web.myaccount/registry [app-atom _]
  (awm.common/screen-wrapper app-atom
    (registries app-atom)))

(defmethod t/transition-open :web.myaccount/registry [app-atom _ _]
  (toaster/open-overlay app-atom :web.myaccount/registries)
  (comms/ajax-get :web.myaccount/registry {}))

(defmethod comms/receive :web.myaccount/registry [app-atom params]
  (toaster/close-overlay app-atom :web.myaccount/registries)
  (swap! (cmn/process-cursor app-atom) assoc :registries (:registries params)))

;; Registry remaining items
#_(rum/defc registry-items [app-atom items]
    [:tr.yc-tr
     [:td.yc-td.yc-td--product-image
      [:a.block-link {:href (:productlink items)}
       [:img.yc-td__image {:src (:productimage items)}]]]
     [:td.yc-td.yc-td--product-text
      [:a.block-link {:href (:productlink items)}
       [:div.yc-td__product-name (:productname items)]
       [:div.yc-td__product-description (:productdescription items)]]]
     [:td.yc-td
      [:span.yc-td__faux-table {:data-th "Price"}
       [:span.yc-td__faux-td (:productprice items)]]]
     [:td.yc-td.yc-td--centered
      [:span.yc-td__faux-table (:data-th "Options")
       [:span.yc-td__faux-td
        (:productoption items)]]]])

;; Registry added items table
#_(rum/defc registry-added-items-table [app-atom]
    (let [items
          [{:productimage "https://res.cloudinary.com/yuppiechef/image/upload/c_lpad,e_sharpen:40,f_auto,h_100,q_auto,w_100/v1/contentdocs/4412/picture20110324165741"
            :productlink "/kitchencraft-cooks-tools.htm?id=4412&name=KitchenCraft-Beech-Wood-Utensils-Set-of-3"
            :productname "KitchenCraft Beech Wood Utensils, Set of 3" :productprice "R95.00" :productoption [:a.text-link.tooltip.tooltip--top {:data-tooltip "Remove" :href "/registry.htm?action=closeParkItem&orderid=4571517&id=17962390"} [:i {:class (u/bem :svg-icon [:delete :is-dark :inline])}]]}]]
      [:table.yc-table.yc-table--order-view.yc-table--underline
       [:caption.yc-table-caption.hidden-from-view "Summary of your items remaining on your registry"]
       [:colgroup
        [:col {:width "150px"}]
        [:col]
        [:col]
        [:col]]
       [:thead.yc-thead
        [:tr.yc-tr
         [:th.yc-th {:scope "col"} "Item"]
         [:th.yc-th {:scope "col"} "Description"]
         [:th.yc-th {:scope "col"} "Price"]
         [:th.yc-th.yc-th--centered {:scope "col"} "Options"]]]

       (into
         [:tbody.yc-tbody]
         (concat
           (map (partial registry-items app-atom)
             items)
           [[:tr.yc-tr.yc-tr--muted
             [:td.yc-td.yc-td--centered {:colspan 4}
              [:span.text-status--important
               [:b "Note: You have some items that weren't purchased by guests. "]
               [:a.text-link.text-link--negative {:href "SCROLLDOWN"}
                "View unbought items."]]]]]))]))

;; Registry remaining items table
#_(rum/defc registry-remaining-items-table [app-atom]
    (let [items
          [{:productimage "https://res.cloudinary.com/yuppiechef/image/upload/c_lpad,e_sharpen:40,f_auto,h_100,q_auto,w_100/v1/contentdocs/45079/otherpicture420200416110644"
            :productlink "/the-apothecary.htm?id=45079&name=The-Apothecary-Herbal-Hand-Sanitiser-30ml"
            :productname "The Apothecary Herbal Hand Sanitiser, 30ml" :productprice "R59.00" :productoption (buttons/button-web "Add" {:href "ADDLINK" :style :primary :size :small})}
           {:productimage "https://res.cloudinary.com/yuppiechef/image/upload/c_lpad,e_sharpen:40,f_auto,h_100,q_auto,w_100/v1/contentdocs/1921/otherpicture39611030135200"
            :productlink "/mode.htm?id=1921&name=Mode-Fridge-Monkey"
            :productname "Mode Fridge Monkey" :productdescription "Charcoal" :productprice "R89.00" :productoption (buttons/button-web "Add" {:href "ADDLINK" :style :primary :size :small})}
           {:productimage "https://res.cloudinary.com/yuppiechef/image/upload/c_lpad,e_sharpen:40,f_auto,h_100,q_auto,w_100/v1/contentdocs/4412/picture20110324165741"
            :productlink "/kitchencraft-cooks-tools.htm?id=4412&name=KitchenCraft-Beech-Wood-Utensils-Set-of-3"
            :productname "KitchenCraft Beech Wood Utensils, Set of 3" :productprice "R95.00" :productoption (buttons/button-web "Add" {:href "ADDLINK" :style :primary :size :small})}]]
      [:table.yc-table.yc-table--order-view
       [:caption.yc-table-caption.hidden-from-view "Summary of your items remaining on your registry"]
       [:colgroup
        [:col {:width "150px"}]
        [:col]
        [:col]
        [:col]]
       [:thead.yc-thead
        [:tr.yc-tr
         [:th.yc-th {:scope "col"} "Item"]
         [:th.yc-th {:scope "col"} "Description"]
         [:th.yc-th {:scope "col"} "Price"]
         [:th.yc-th.yc-th--centered {:scope "col"} "Options"]]]

       (into
         [:tbody.yc-tbody]
         (map (partial registry-items app-atom)
           items))]))

;; Registry view (close)
#_(rum/defc registry-view-close < rum/reactive [app-atom]
    (let [process-atom (rum/react (cmn/process-cursor app-atom))]
      (list
        [:div.dashboard.dashboard--s-t-margin
         (headings/heading "Close your Registry" {:type :h2 :size :medium})
         (feedback/feedback :info "" "Unfortunately no purchases were made on your registry. You can choose to purchase some items off your registry and checkout as usual, or delete your registry.")
         [:p.yc-paragraph.u-max-width-720
          "Don't want to close just yet? You can "
          [:a.text-link {:href "REOPENREGISTRY"} "reopen your Registry."]]

         (headings/heading "Items to be checked out" {:type :h3 :size :small})
         (registry-added-items-table app-atom)]

        [:div {:class (u/bem :yc-section [:standard])}
         [:div.flex-grid-group
          [:div {:class (u/bem :flex-grid-block [:ml-1-2 :ml-order-02 :l-2-5 :ml-right])}
           [:div.flex-grid-content
            [:div.order-cost-summary
             [:order-cost__already-paid
              "Paid for by guests: R800.00"
              [:br]
              [:small "Including Gift Vouchers"]]
             [:div.order-cost__total
              "Owing: R200.00"]
             [:div.order-cost__not-paid
              [:span.text-status--important "You still have R500.00 to spend"]
              [:br]
              [:small "Add more items or redeem in Yuppiechef Vouchers"]]
             [:div.order-cost__button-wrapper
              (buttons/button-web "Close Registry"
                {:style :primary
                 :size :default
                 :full true
                 :class "checkout-button"
                 :custom-attrs {:data-dialog-open "dialog-voucher"}})]]]]
          [:div {:class (u/bem :flex-grid-block [:ml-1-2 :ml-order-01 :l-3-5])}
           [:div.flex-grid-content
            [:aside.order-delivery-note
             (headings/heading "Delivery Charges" {:type :h4 :size :tiny})
             [:p.delivery-note__description "Based on your current guest purchases your expected delivery costs are R200.00"]]]]]]

        [:div.dashboard
         (headings/heading "Remaining items" {:type :h3 :size :small})
         (registry-remaining-items-table app-atom)
         [:div.dashboard-footer.button-group
          (buttons/button-web "Add more gifts"
            {:href "/"
             :style :primary
             :size :small})]])))

#_(defmethod flow/render-screen :web.myaccount/registry-view-close [app-atom _]
    (awm.common/screen-wrapper app-atom
      (registry-view-close app-atom)))

